import React, { FC, useState, useEffect, PropsWithChildren, createContext, memo } from 'react';
import classNames from 'classnames';
import View from '../view';

interface ICheckboxGroupProps {
  className?: string;
  value?: string[];
  defaultValue?: string[];
  disabled?: boolean;
  onChange?: (value: string[]) => void;
}

interface IToggleOptionProps {
  value?: string;
  checked: boolean;
}

interface ICheckboxGroupContext {
  value?: string[];
  disabled?: boolean;
  isControlled?: boolean;
  toggleOption: (option: IToggleOptionProps) => void;
}

export const GroupContext = createContext<ICheckboxGroupContext | null>(null);

const defaultSelectedList = [];

const CheckboxGroup: FC<PropsWithChildren<ICheckboxGroupProps>> = memo(({ children, className = '', value: propsValue, defaultValue = defaultSelectedList, disabled, onChange }) => {
  const [value, setValue] = useState<string[]>(propsValue || defaultValue);
  const isControlled = !!propsValue; // 是否为受控组件

  const rootCls = classNames('ink-checkbox-group', className);

  const context = {
    toggleOption: (toggledOpt) => {
      const selectedSet = new Set(value);
      if (toggledOpt.checked) {
        selectedSet.add(toggledOpt.value);
      } else {
        selectedSet.delete(toggledOpt.value);
      }
      /**
       * props.value 传入，为受控组件，通过 onChange 事件来更新 selectedList
       * props.value 未传入，未非受控组件，使用内部状态更新，但仍调用 onChange 回调
       */
      if (!isControlled) {
        setValue([...selectedSet]);
      }
      if (onChange) {
        onChange([...selectedSet]);
      }
    },
    value,
    isControlled,
    disabled,
  };

  useEffect(() => {
    if (propsValue) {
      setValue(propsValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(propsValue)]);

  return (
    <View className={rootCls}>
      <GroupContext.Provider value={context}>{children}</GroupContext.Provider>
    </View>
  );
});

export default CheckboxGroup;
